import {
  WSContainer,
  WSGrid,
  WSLayout,
  WSText
} from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { FormCardAcknowledgements } from "../components/FormCardAcknowledgements";
import { WALLET_ROOT_PATH } from "../index";
import { useActivateVirtualCardModal } from "../modals/CreateVirtualCard/useActivateVirtualCardModal";
import { useCardCreatedModal } from "../modals/CreateVirtualCard/useCardCreatedModal";
import { useCreateVirtualCardModal } from "../modals/CreateVirtualCard/useCreateVirtualCardModal";
import { useModalAddCardToDigitalWallet } from "../modals/ModalAddCardToDigitalWallet";
import { WalletCardType } from "../types";

export const RouteActivateVirtualCard = () => {
  const history = useHistory();
  const activateVirtualCardModal = useActivateVirtualCardModal();
  const createVirtualCardModal = useCreateVirtualCardModal();
  const cardCreatedModal = useCardCreatedModal();
  const modalAddCardToDigitalWallet = useModalAddCardToDigitalWallet();

  return (
    <WSLayout
      headerCenter={
        <WSText.ParagraphSm weight="medium">
          Activate virtual card
        </WSText.ParagraphSm>
      }
      smallHeader={true}
      onClose={() => {
        history.push("/member/wallet");
      }}
      line
    >
      <WSContainer verticalPadding>
        <WSGrid>
          <WSGrid.Item span={{ m: "2" }} />
          <WSGrid.Item span={{ m: "8" }}>
            <FormCardAcknowledgements
              cardType={WalletCardType.Virtual}
              onBack={() => {
                history.push(WALLET_ROOT_PATH);
              }}
              onContinue={async () => {
                await createVirtualCardModal.open({
                  onSuccess: card => {
                    activateVirtualCardModal.open({
                      cardId: card.id,
                      onSuccess: () => {
                        cardCreatedModal.open({
                          onSuccess: () => {
                            modalAddCardToDigitalWallet.open({
                              onClose: () => {
                                history.push(WALLET_ROOT_PATH);
                              }
                            });
                          }
                        });
                      }
                    });
                  }
                });
              }}
            />
          </WSGrid.Item>
        </WSGrid>
      </WSContainer>
    </WSLayout>
  );
};
